module.exports = __webpack_public_path__ + "img/21.bcca82e9.png";